import { render, staticRenderFns } from "./WatchIcon.vue?vue&type=template&id=a3dbedfe&"
import script from "./WatchIcon.vue?vue&type=script&lang=js&"
export * from "./WatchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports